import { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader2, Check, XCircle, ArrowLeft } from 'lucide-react';
import { verifyEmail, ApiException } from '../api/client';
import { useAuth } from '../App';

export default function VerifyEmailPage() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const { refresh } = useAuth();

  const [loading, setLoading] = useState(true);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!token) {
      setError('Kein Token vorhanden');
      setLoading(false);
      return;
    }

    verifyEmail(token)
      .then(async () => {
        setSuccess(true);
        try { await refresh(); } catch {}
      })
      .catch((err) => {
        if (err instanceof ApiException) {
          setError(err.data.error || 'Fehler bei der Bestaetigung');
        } else {
          setError('Verbindungsfehler');
        }
      })
      .finally(() => {
        setLoading(false);
      });
  }, [token]);

  return (
    <div className="min-h-screen bg-slate-100 flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-white rounded-lg shadow-lg p-8 text-center">
        {loading ? (
          <>
            <Loader2 className="w-12 h-12 text-slate-400 animate-spin mx-auto mb-4" />
            <p className="text-slate-500">E-Mail wird bestaetigt...</p>
          </>
        ) : success ? (
          <>
            <div className="w-16 h-16 rounded-full bg-green-100 flex items-center justify-center mx-auto mb-4">
              <Check className="w-8 h-8 text-green-600" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">E-Mail bestaetigt</h1>
            <p className="text-slate-500 mb-6">
              Ihre E-Mail-Adresse wurde erfolgreich geaendert.
            </p>
            <Link
              to="/profile"
              className="inline-flex items-center justify-center gap-2 w-full py-2 px-4 bg-slate-900 hover:bg-slate-800 text-white rounded-md font-medium transition-colors"
            >
              Zum Profil
            </Link>
          </>
        ) : (
          <>
            <div className="w-16 h-16 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
              <XCircle className="w-8 h-8 text-red-600" />
            </div>
            <h1 className="text-xl font-bold text-slate-900 mb-2">Fehler</h1>
            <p className="text-slate-500 mb-6">{error}</p>
            <Link
              to="/profile"
              className="inline-flex items-center gap-2 text-slate-600 hover:text-slate-900 transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Zum Profil
            </Link>
          </>
        )}
      </div>
    </div>
  );
}
